var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"contenter"},[_c('property-service',{ref:"propertyService",attrs:{"typeIndex":"1"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }